import React, { useCallback, useState } from 'react'
import EnableAutoPricing from 'components/QuestionnaireRequest/AdminNew/Tabs/Pricing/EnableAutoPricing'
import Pricing from 'components/QuestionnaireRequest/AdminNew/Tabs/Pricing/Pricing'
import { useDispatch, useSelector } from 'react-redux'
import {
  setIsAutoPricingEnabled,
  addNewPrice,
  removePrice,
  updatePrice,
} from 'components/QuestionnaireRequest/AdminNew/store/slice'

export default function QuestionnaireAdminTabPricing(props) {
  const dispatch = useDispatch()
  const { isAutoPricingEnabled, prices } = useSelector((state) => state.organizationQuestionnaireAdmin)
  const onAddNewPrice = useCallback((newItem) => dispatch(addNewPrice(newItem)), [dispatch])
  const onUpdatePrice = useCallback(
    ({ oldId, updatedPrice }) => dispatch(updatePrice({ oldId, updatedPrice })),
    [dispatch]
  )
  const onRemovePrice = useCallback((priceId) => dispatch(removePrice(priceId)), [dispatch])

  return (
    <div style={{ marginTop: 30 }}>
      <div className="dome-d-flex dome-flex-column dome-gap30">
        <EnableAutoPricing
          organizationId={props.organization.id}
          enabled={isAutoPricingEnabled}
          updateEnabled={(enabled) => dispatch(setIsAutoPricingEnabled(enabled))}
        />
        <div className="questionnaire-admin-general-table-container">
          <Pricing
            organizationId={props.organization.id}
            prices={prices}
            onAddNewPrice={onAddNewPrice}
            onUpdatePrice={onUpdatePrice}
            onRemovePrice={onRemovePrice}
          />
        </div>
      </div>
    </div>
  )
}
